import { connect } from 'react-redux';
import AuthButton from "../components/AuthButton";
import withRouter from "../../Common/hocs/withRouter";
import { logoutAsStudentProxy, resetState, STUDENT_PROXY_LOGOUT } from "../../actions-index";

const mapStateToProps = (state, ownProps) => {
    const { authentication, studentProxyLogin = {}, studentProxyLogout = {} } = state;
    const { user = {}, status = '' } = authentication;
    const { status: studentProxyLoginStatus = "" } = studentProxyLogin;
    const { status: studentProxyLogoutStatus = "" } = studentProxyLogout;

    return {
        status,
        studentProxyLoginStatus,
        studentProxyLogoutStatus,
        user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logoutAsStudentProxy: () => dispatch(logoutAsStudentProxy()),
        resetStudentProxyLogout: () => dispatch(resetState(STUDENT_PROXY_LOGOUT, {}))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthButton));
